<template>
	<div>
		<v-container>
			<v-card :loading="loading">
				<v-card-title primary-title>
					<div class="title">User modification</div>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid">
						<v-row justify="center" dense>
							<v-col cols="12" class="pb-0 pt-6">
								<v-row align="center">
									<v-col class="shrink">
										<v-label>Account&nbsp;Information</v-label>
									</v-col>
									<v-col class="expand">
										<v-divider></v-divider>
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-autocomplete
									v-model="userType"
									label="User type"
									:items="userTypes"
									:rules="[rules.required]"
									item-text="description"
									item-value="id"
								></v-autocomplete>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="clinicId" label="Clinic ID" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="password" label="Password" :rules="[rules.optionalPassword]"></v-text-field>
							</v-col>

							<v-col cols="12" class="pb-0 pt-6">
								<v-row align="center">
									<v-col class="shrink">
										<v-label>Personal&nbsp;Information</v-label>
									</v-col>
									<v-col class="expand">
										<v-divider></v-divider>
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="patient_id"
									label="Patient National ID"
									:rules="[rules.required, rules.nationalId]"
									disabled
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-autocomplete
									v-model="nationality"
									label="Nationality"
									:items="nationalities"
									:rules="[rules.required]"
									item-value="id"
									item-text="description"
								></v-autocomplete>
							</v-col>

							<v-col cols="12" md="4" class="py-0">
								<v-text-field v-model="first_name" label="First Name" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" md="4" class="py-0">
								<v-text-field v-model="middle_name" label="Middle Name" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" md="4" class="py-0">
								<v-text-field v-model="last_name" label="Last Name" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" md="8" class="py-0">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="date"
											label="Date of Birth"
											readonly
											:rules="[rules.required]"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										ref="picker"
										v-model="date"
										:max="new Date().toISOString().substr(0, 10)"
										min="1950-01-01"
										@change="save"
									></v-date-picker>
								</v-menu>
							</v-col>

							<v-col cols="12" md="4" class="py-0">
								<v-text-field label="Age" :value="age" suffix="years" disabled></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<div class="subtitle-1 pt-4">Gender</div>
								<v-radio-group v-model="gender" class="pa-0" :rules="[rules.required]">
									<v-radio color="primary" label="Male" value="Male"></v-radio>
									<v-radio color="primary" label="Female" value="Female"></v-radio>
								</v-radio-group>
							</v-col>

							<v-col cols="12" class="pb-0 pt-6">
								<v-row align="center">
									<v-col class="shrink">
										<v-label>Contact&nbsp;Information</v-label>
									</v-col>
									<v-col class="expand">
										<v-divider></v-divider>
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="cellphone" label="Cellphone Number" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="phone" label="Phone Number"></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="email" label="Email" :rules="[rules.required, rules.email]"></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0 text-center">
								<v-btn
									color="primary"
									class="text-none mx-1"
									rounded
									:disabled="!valid"
									@click="updatePatient"
								>
									<template>Update</template>
								</v-btn>
								<v-btn color="error" class="text-none mx-1" rounded outlined @click="goHome">Cancel</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
const axios = require("axios");

export default {
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/rules-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/user-types-mixin").default
	],
	data: () => ({
		date: null,
		menu: false,
		age: null,
		patient_id: null,
		first_name: null,
		middle_name: null,
		last_name: null,
		phone: null,
		cellphone: null,
		email: null,
		gender: null,
		valid: false,
		nationality: null,
		nationalities: [],
		password: null,
		userType: null,
		clinicId: null,
		loading: true
	}),
	watch: {
		menu(val) {
			val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
		},
		date() {
			this.setAge(this.date);
		}
	},
	mounted() {
		this.getPatientInfo();

		this.getNationalities();
	},
	methods: {
		getNationalities() {
			const url = this.BACKEND_URL + "/api/allNationalities";

			let thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						console.log(response.data);
						thisVue.nationalities = response.data;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getPatientInfo() {
			var id = this.$route.params.patientId;
			this.patient_id = this.$route.params.patientId;

			const url = this.BACKEND_URL + "/api/getUserById/" + id;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						thisVue.loading = false;
						console.log("200");
						console.log(response.data);
						var user = response.data;
						setTimeout(() => {
							thisVue.first_name = user.FirstName;
							thisVue.middle_name = user.FatherName;
							thisVue.last_name = user.FamilyName;

							thisVue.date = user.birth;
							thisVue.phone = user.phone;
							thisVue.cellphone = user.cellphone;
							thisVue.email = user.email;
							thisVue.gender = user.gender;
							thisVue.nationality = user.Nationality;

							thisVue.clinicId = user.Clinic;
							thisVue.userType = user.UserType;
						}, 50);
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		save(date) {
			this.$refs.menu.save(date);
		},
		setAge(dateString) {
			var today = new Date();
			var birthDate = new Date(dateString);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			this.age = age;
		},
		goHome() {
			this.$router.push("/dashboard/users");
		},
		updatePatient() {
			const url = this.BACKEND_URL + "/api/updateUser";

			var userType = this.userType;

			var data = new FormData();

			data.append("nationalId", this.patient_id);
			data.append("FirstName", this.first_name);
			data.append("FatherName", this.middle_name);
			data.append("FamilyName", this.last_name);
			data.append("Nationality", this.nationality);
			data.append("birth", this.date);
			data.append("gender", this.gender);
			data.append("phone", this.phone);
			data.append("email", this.email);
			data.append("cellphone", this.cellphone);
			data.append("Clinic", this.clinicId);
			data.append("UserType", userType);
			data.append("password", this.password);

			var token = this.getBackendToken();
			data.append("token", token);

			let thisVue = this;
			let config = {};

			axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.$store.commit("pushNotification", {
							message: "Data updated for " + thisVue.first_name
						});
						thisVue.goHome();
					}
				})
				.catch(error => {
					console.error(error);
				});
		}
	}
};
</script>

<style>
.v-input--selection-controls:not(.v-input--) .v-input__slot,
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
	margin-bottom: 0;
}
.v-input--checkbox,
.v-input--radio-group {
	margin-top: 0;
	margin-bottom: 0;
}
</style>
